/* src/modules/create_tutor/cards/AddTutorsSuccessCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
} from '@material-ui/core';
import { PaperHeader } from '../../../../app/components';

import styles from './styles';

import { getTutors } from '../../selectors';
import { clearAddedTutors } from '../../actions';
import { loadTexts } from '../../../../config/texts';

const TEXT_KEY = "create_tutors";

class AddTutorsSuccessCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      texts: loadTexts(TEXT_KEY, props.locale)
    }
    this._onPressClear = this._onPressClear.bind(this);
  }

  _onPressClear() {
    this.props.clearAddedTutors();
  }

  renderAdded(classes) {
    const { tutors } = this.props;
    const { texts } = this.state;
    const { fields } = texts;
    if (isEmpty(tutors)) {
      return (
        <Typography className={classes.label}>
          {texts.no_tutors}
        </Typography>
      );
    }
    return (
      <React.Fragment>
        <Typography className={classNames(classes.label, classes.greenText)}>
          {`${fields.add_success} ${tutors.length} ${fields.tutor}${tutors.length === 1 ? '' : 's'}`}
        </Typography>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{fields.name}</TableCell>
              <TableCell>{fields.email}</TableCell>
              <TableCell>{fields.courses}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {tutors.map(({ name, email, courses }, i) => (
              <TableRow key={`${email}-${i}`}>
                <TableCell>{name}</TableCell>
                <TableCell>{email}</TableCell>
                <TableCell>{courses}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </React.Fragment>
    );
  }

  renderClearButton(classes) {
    const { texts: { fields: { clear } } } = this.state;
    return (
      <Button
        disabled={isEmpty(this.props.tutors)}
        className={classes.button}
        variant="raised"
        onClick={this._onPressClear}
      >
        {clear}
      </Button>
    );
  }

  render() {
    const { classes } = this.props;
    const { texts } = this.state;
    return (
      <Paper className={classes.paper}>
        <div className={classes.header}>
          <PaperHeader text={texts.title.added_tutors} />
          {this.renderClearButton(classes)}
        </div>
        {this.renderAdded(classes)}
      </Paper>
    );
  }
}

AddTutorsSuccessCard.propTypes = {
  classes: PropTypes.object.isRequired,
  tutors: PropTypes.array.isRequired,
  clearAddedTutors: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  tutors: getTutors(state),
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  clearAddedTutors: () => dispatch(clearAddedTutors()),
});

export default compose(
  withStyles(styles, { name: 'AddTutorsSuccessCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(AddTutorsSuccessCard);



// WEBPACK FOOTER //
// ./src/modules/create_tutor/cards/AddTutorsSuccessCard/index.js